import { getAmplitudeInstance } from '../amplitudeHelpers';
import WaypointCategoryValue from '../enums/WaypointCategoryValue';
import WaypointEntryPoint from '../enums/WaypointEntryPoint';
import WaypointSourceKindValue from '../enums/WaypointSourceKindValue';
import WaypointSourceView from '../enums/WaypointSourceView';

type logWaypointDeletedParams = {
  category?: WaypointCategoryValue;
  content_privacy?: string;
  entry_point: WaypointEntryPoint;
  is_global?: boolean;
  source_kind?: WaypointSourceKindValue;
  source_view?: WaypointSourceView;
  waypoint_id?: number;
};

/**
 * User confirms deletion of an existing waypoint.
 * @param params - Attributes to log with the amplitude event
 * @param params.category - The category of the waypoint that was deleted.
 * @param params.content_privacy - The privacy level of the waypoint that was deleted.
 * @param params.entry_point - The surface from which the waypoint was deleted.
 * @param params.is_global - Whether the deleted waypoint was globally visible across maps.
 * @param params.source_kind - The origin of the waypoint (route-specific or user global).
 * @param params.source_view - The UI element from which deletion was triggered (e.g. edit_form or overflow_menu).
 * @param params.waypoint_id - The remote server ID of the waypoint, if synced.
 */
const logWaypointDeleted = (
  { category, content_privacy, entry_point, is_global, source_kind, source_view, waypoint_id }: logWaypointDeletedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'waypoint deleted',
    {
      category,
      'content privacy': content_privacy,
      'entry point': entry_point,
      'is global': is_global,
      'source kind': source_kind,
      'source view': source_view,
      'waypoint id': waypoint_id
    },
    callback
  );
};

export default logWaypointDeleted;
